// extracted by mini-css-extract-plugin
export default {"fieldset":"PhoneNumber_fieldset__0nnQv","actions":"PhoneNumber_actions__mvSnp"};